import { useState } from 'react';
import { Props_SnippetTabSwitcher } from './TabSwitcher.props';
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';
import SnippetLink from '../Shared/Link/Link';
import SharedHeading from '../Shared/Heading/Heading';

const SnippetTabSwitcher = (props: Props_SnippetTabSwitcher) => {
    const { heading, repeatable_tab } = props

    const [activeTab, setActiveTab] = useState(0)
    
    const snippetID = Math.random().toString(36).substring(2, 10)
    const classParagraphAlignment: string = heading.paragraphAlignment.value ? `snippet-tab-switcher__paragraph--${heading.paragraphAlignment.value}` : ''

    return (
        <section className="snippet-tab-switcher">
            <span className="snippet-tab-switcher__desktop-top-shape"></span>
            <div className="snippet-tab-switcher__container">
                <div className="snippet-tab-switcher__heading-section">
                <SharedHeading
                  className={`snippet-tab-switcher__heading`}
                  level={heading.level?.value as 'h1'|'h2'|'h3'|'h4'|'h5'|'h6' || 'h2'}
                  alignment={heading.alignment?.value as 'start'|'center'|'end'}
                  visibility={typeof heading.visibility?.value === 'boolean' ? heading.visibility.value : heading.visibility?.value === 'true'}
                >
                  {heading?.text?.value}
                </SharedHeading>

                {heading?.paragraph?.value && typeof heading.paragraph.value === 'string' && (
                  <div className={`snippet-tab-switcher__paragraph ${classParagraphAlignment}`}>
                    {CompileMarkdown(heading.paragraph.value)}
                  </div>
                )}
                </div>
                <div className="snippet-tab-switcher__container-wrapper">
                    <div
                        role="tablist"
                        aria-labelledby={`snippet-tab-switcher-${snippetID}`}
                        className={`snippet-tab-switcher__container-tabs`}
                    >
                        { repeatable_tab.map((tab, index) => (
                            <button
                                key={`snippet-tab-switcher-${snippetID}-${index}`}
                                role="tab"
                                aria-selected={activeTab === index}
                                aria-controls={`snippet-tab-switcher-${snippetID}-${index}`}
                                className={`snippet-tab-switcher__tabs-button${activeTab === index ? ' snippet-tab-switcher__tabs-button--active' : ''}`}
                                onClick={() => setActiveTab(index)}
                            >
                                {tab?.heading?.value}
                            </button>
                        ))}
                    </div>
                    <div className="snippet-tab-switcher__container-content">
                        { repeatable_tab.map((tab, index) => (
                            <article
                                key={`snippet-tab-switcher-${snippetID}-${index}`}
                                id={`snippet-tab-switcher-${snippetID}-${index}`}
                                role="tabpanel"
                                aria-hidden={activeTab !== index}
                                className={`snippet-tab-switcher__tab${activeTab === index ? ' snippet-tab-switcher__tab--active' : ''}`}
                            >
                                
                                <div className="snippet-tab-switcher__tab-container">
                                    { tab.image?.value && (
                                        <figure className="snippet-tab-switcher__tab-image-container">
                                        <img
                                            className="snippet-tab-switcher__tab-image"
                                            src={tab.image.value}
                                            alt={tab.alt?.value ? tab.alt.value : ''}
                                            loading="lazy"
                                            height="300"
                                            width="300"
                                        /></figure>
                                    )}
                                    <div className="snippet-tab-switcher__tab-container-content">
                                        <SharedHeading level="h3" className="snippet-tab-switcher__tab-heading">
                                  {tab.heading?.value}
                                </SharedHeading>
                                        { tab.content?.value && <div className="snippet-tab-switcher__tab-content">{ CompileMarkdown(tab.content.value) }</div> }
                                        <SnippetLink
                                            url={tab.linkHref?.value ?? ''}
                                            className="snippet-tab-switcher__tab-link"
                                            linkStyles={tab.linkStyle?.value}
                                            openInNewTab={tab.linkTarget?.value === true}
                                        >
                                            {tab.linkText?.value ?? ''}
                                        </SnippetLink>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
            <span className="snippet-tab-switcher__desktop-bottom-shape"></span>
        </section>
    )
}

export default SnippetTabSwitcher